import script from "./NetworkRecordsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkRecordsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkRecordsDialog.vue?vue&type=style&index=0&id=dda81a18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dda81a18"]])

export default __exports__